import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "./store";
import firebase from "firebase";
import VueAnalytics from "vue-analytics";
import cookieconsent from "vue-cookieconsent-component";
import Vuelidate from "vuelidate";
require("firebase/firestore");
require("firebase/app");
import ZoomOnHover from "vue-zoom-on-hover";

Vue.config.productionTip = false;
Vue.component("cookie-consent", cookieconsent);
Vue.use(require("vue-cookies"));
Vue.$cookies.config("90d");
Vue.use(ZoomOnHover),
Vue.use(VueAnalytics, {
  id: "UA-183056413-1",
  router,
  disabled: true
  // debug: {
  //   sendHitTask: false
  // }
});
Vue.use(Vuelidate);

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App),
}).$mount("#app");

firebase.initializeApp({
  apiKey: "AIzaSyAg0tDx4fE8nw12RLMTeMN8yGw0AYl8RS0",
  authDomain: "heberlein-kraeutertee.firebaseapp.com",
  databaseURL: "https://heberlein-kraeutertee.firebaseio.com",
  projectId: "heberlein-kraeutertee",
  storageBucket: "heberlein-kraeutertee.appspot.com",
  messagingSenderId: "528003471828",
  appId: "1:528003471828:web:e237b507d0260f4f93de41",
  measurementId: "G-JRYNX5XZTC"
});
firebase.analytics();
Vue.prototype.$firebaseDatabase = firebase.default.firestore();
